/**
 * Persist user language preference so we can default to Finnish or English on "/".
 * Cookie is set when the user navigates (sync from current path) and when they use the language switcher.
 */

const COOKIE_NAME = 'identio_preferred_lang';
const COOKIE_MAX_AGE_DAYS = 365;

export function getPreferredLangFromCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  const value = match ? decodeURIComponent(match[1]).toLowerCase() : null;
  return value === 'fi' || value === 'en' ? value : null;
}

export function setPreferredLangCookie(lang) {
  if (typeof document === 'undefined' || (lang !== 'fi' && lang !== 'en')) return;
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${lang}; path=/; max-age=${maxAge}; SameSite=Lax`;
}
